import React from 'react'

import { DashboardItemProps } from '../types'
import { MainTitleContainer } from './MainTitle.styled'

function MainTitle({ componentStyle, data }: DashboardItemProps) {
    return (
        <MainTitleContainer componentStyle={componentStyle}>
            <h3>
                {data.title}
                {data.subtitle && <small>{data.subtitle}</small>}
            </h3>
        </MainTitleContainer>
    )
}

export default MainTitle
